/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useState, useRef, useEffect } from 'react';
import {
  Col,
  Row,
  Card,
  Input,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import {
  SpText, SpButton, SpError,
} from 'components/DesignKit';
import {
  PAGES,
} from 'appconstants';
import Loading from 'components/Loading';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { lynxTenantDetailActions, notificationActions } from 'store/actions';

type Props = {
  loader: boolean,
  validator: boolean,
  lynxTenantDetails: Array,
  addInternalLynxTenantDetail: Function,
  updateInternalLynxTenantDetail: Function,
  fetchInternalLynxTenantDetail: Function,
  deleteInternalLynxTenantDetail: Function,
};

const LynxTenantDetail = (props: Props) => {
  const {
    loader,
    validator,
    lynxTenantDetails,
    addInternalLynxTenantDetail,
    updateInternalLynxTenantDetail,
    fetchInternalLynxTenantDetail,
    deleteInternalLynxTenantDetail,
  } = props;
  const history = useHistory();
  const [, forceUpdate] = useState();
  const [tenantId, setTenantId] = useState(null);
  const [apiUrl, setApiUrl] = useState(null);
  const [apiKey, setApiKey] = useState(null);
  const [redirect, setRedirect] = useState(false);
  const [edit, setEdit] = useState(false);
  const simpleValidator = useRef(new SimpleReactValidator());
  const lynxTenantDetailGid = (lynxTenantDetails && lynxTenantDetails.length !== 0 && lynxTenantDetails[0] && lynxTenantDetails[0].gid) || '';

  const addNewLynxTenantDetail = () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    const params = {
      tenantId,
      apiUrl,
      apiKey,
    };
    addInternalLynxTenantDetail({
      params,
    });
    setEdit(false);
    setRedirect(true);
  };

  const updateLynxTenantDetail = () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    const params = {
      tenantId,
      apiUrl,
      apiKey,
    };
    updateInternalLynxTenantDetail({
      gid: lynxTenantDetailGid,
      params,
    });
    setEdit(false);
    setRedirect(true);
  };

  const deleteLynxTenantDetail = () => {
    deleteInternalLynxTenantDetail({
      gid: lynxTenantDetailGid,
    });
    setTenantId(null);
    setApiUrl(null);
    setApiKey(null);
    setEdit(false);
    setRedirect(true);
  };

  useEffect(() => {
    fetchInternalLynxTenantDetail();
  }, []);

  useEffect(() => {
    if (lynxTenantDetails && lynxTenantDetails.length !== 0) {
      setTenantId(lynxTenantDetails && lynxTenantDetails[0] && lynxTenantDetails[0].tenantId);
      setApiUrl(lynxTenantDetails && lynxTenantDetails[0] && lynxTenantDetails[0].apiUrl);
      setApiKey(lynxTenantDetails && lynxTenantDetails[0] && lynxTenantDetails[0].apiKey);
    }
  }, [lynxTenantDetails]);

  useEffect(() => {
    if (!validator && redirect) {
      history && history.push(PAGES.SETTINGS);
    }
  }, [validator]);

  const handleEdit = () => {
    setEdit(!edit);
  };

  const handleCancel = () => {
    setEdit(false);
    if (lynxTenantDetails && lynxTenantDetails.length !== 0) {
      setTenantId(lynxTenantDetails && lynxTenantDetails[0] && lynxTenantDetails[0].tenantId);
      setApiUrl(lynxTenantDetails && lynxTenantDetails[0] && lynxTenantDetails[0].apiUrl);
      setApiKey(lynxTenantDetails && lynxTenantDetails[0] && lynxTenantDetails[0].apiKey);
    } else {
      setTenantId(null);
      setApiUrl(null);
      setApiKey(null);
    }
  };

  if (loader) {
    return <Loading />;
  }

  return (
    <>
      <Card className="pl-2 mb-3">
        <>
          <Row className="mt-3 " type="flex" justify="end" gutter={[16, 16]}>
            <Col>
              {edit ? (
                <>
                  <SpButton
                    type="secondary"
                    shape="round"
                    className="mr-3"
                    onClick={() => handleCancel()}
                  >
                    Cancel
                  </SpButton>
                  <SpButton
                    type="primary"
                    shape="round"
                    onClick={() => {
                      if (lynxTenantDetailGid) {
                        updateLynxTenantDetail();
                      } else {
                        addNewLynxTenantDetail();
                      }
                    }}
                  >
                    {lynxTenantDetailGid ? 'Update' : 'Save'}
                  </SpButton>
                </>
              ) : (
                <>
                  <SpButton
                    type="secondary"
                    shape="round"
                    className="mr-3"
                    onClick={() => handleEdit()}
                  >
                    Edit
                  </SpButton>
                  {lynxTenantDetailGid && (
                    <SpButton
                      type="danger"
                      shape="round"
                      onClick={() => deleteLynxTenantDetail()}
                    >
                      Delete
                    </SpButton>
                  )}
                </>
              )}
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mb-3">
            <Col span={8}>
              <SpText fontWeight="600">Tenant Id</SpText>
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mb-3">
            <Col span={8}>
              <Input
                placeholder="Tenant Id"
                disabled={!edit}
                onChange={(e) => setTenantId(e.currentTarget.value)}
                value={tenantId}
              />
              <SpError>
                {simpleValidator.current.message('Tenant Id', tenantId, 'required')}
              </SpError>
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mt-3 mb-3">
            <Col span={8}>
              <SpText fontWeight="600">Api Url</SpText>
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mb-3">
            <Col span={8}>
              <Input
                placeholder="Api Url"
                disabled={!edit}
                onChange={(e) => setApiUrl(e.currentTarget.value)}
                value={apiUrl}
              />
              <SpError>
                {simpleValidator.current.message('Api Url', apiUrl, 'required')}
              </SpError>
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mt-3 mb-3">
            <Col span={8}>
              <SpText fontWeight="600">Api Key</SpText>
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mb-3">
            <Col span={8}>
              <Input
                placeholder="Api Key"
                disabled={!edit}
                onChange={(e) => setApiKey(e.currentTarget.value)}
                value={apiKey}
              />
              <SpError>
                {simpleValidator.current.message('Api Key', apiKey, 'required')}
              </SpError>
            </Col>
          </Row>
        </>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  lynxTenantDetails: state.lynxTenantDetails.lynxTenantDetails,
  loader: state.loading.loading,
  submitting: state.loading.submitting,
  validator: state.loading.validator,
  test: state.account.test,
});

const mapDispatchToProps = (dispatch) => ({
  deleteInternalLynxTenantDetail: param => dispatch(lynxTenantDetailActions.deleteInternalLynxTenantDetail({
    payload: param,
  })),
  updateInternalLynxTenantDetail: param => dispatch(lynxTenantDetailActions.updateInternalLynxTenantDetail({
    payload: param,
  })),
  fetchInternalLynxTenantDetail: param => dispatch(lynxTenantDetailActions.fetchInternalLynxTenantDetails({
    payload: param,
  })),
  addInternalLynxTenantDetail: param => dispatch(lynxTenantDetailActions.addInternalLynxTenantDetail({
    payload: param,
  })),
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
});


export default connect(mapStateToProps, mapDispatchToProps)(LynxTenantDetail);
